import React from 'react';

import { Box, Typography } from '@mui/material';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { ActionItemStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { useProviderTrainingsQuery } from '@uplift/queries';
import { BaseDashboardActionItem, LightChip } from '@uplift/ui-v2';

import { getChipColor } from '../../../helpers';
import { useSharedStyles } from '../../../styles';
import { RequiredTrainingsCard } from './RequiredTrainingsCard';

export type RequiredTrainingsProps = {
  status: ActionItemStatus;
};

export const RequiredTrainings: React.VFC<RequiredTrainingsProps> = ({ status }) => {
  const l10n = useL10n();
  const me = useCurrentuser();
  const { classes: sharedClasses } = useSharedStyles();
  const { data, isLoading } = useProviderTrainingsQuery(me?.id, { requiredOnly: true });

  if (isLoading || !data) {
    return null;
  }

  if (status === ActionItemStatus.done) {
    return (
      <Box className={sharedClasses.progressSummaryStepWithChip}>
        <Typography variant="h5">{l10n.dashboard.actionItems.requiredTrainings.title}</Typography>
        <LightChip label={l10n.dashboard.actionItems.status[status]} color={getChipColor(status)} size="small" />
      </Box>
    );
  }

  const { trainings, lastSyncedAt } = data;

  if (trainings.length === 0) {
    return (
      <BaseDashboardActionItem
        icon={<SchoolOutlinedIcon />}
        color="primary"
        title={l10n.dashboard.actionItems.requiredTrainings.title}
        body={l10n.dashboard.actionItems.requiredTrainings.pending}
      />
    );
  }

  return <RequiredTrainingsCard trainings={trainings} lastSyncedAt={lastSyncedAt} />;
};
